export default {
      id: "Icon--fullscreenCancel-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--fullscreenCancel",
      toString: function () {
        return this.url;
      }
    }